<template>
  <div class="nav-container">
    <div class="left">
      <el-menu mode="horizontal" active-text-color="#D04247" :default-active="indexPath" @select="clickHeaderNav">
        <el-menu-item v-for="headerTabItem in headerTabMenu" :key="headerTabItem.id" :index="headerTabItem.path">{{
          headerTabItem.title }}
        </el-menu-item>
      </el-menu>
    </div>

    <div class="right">
      <div class="badgebox">
        <el-badge :value="massageNum">
          <div class="bellbox" @click="sendTips">
            <i class="el-icon-bell" style="font-size: 24px"></i>
          </div>
        </el-badge>
      </div>
      <div class="userbox">
        <span class="usertext">{{ userInfo.nickname }}</span>
        <el-avatar shape="circle" :size="30" :src="circleUrl"></el-avatar>
        <!-- <el-avatar shape="circle" :size="30" :src="userInfo.thumb"></el-avatar> -->

        <el-dropdown>
          <span class="el-dropdown-link">
            <i class="el-icon-caret-bottom" style="color: #d8d8d8"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown">
            <el-dropdown-item disabled>管理首页</el-dropdown-item>
            <el-dropdown-item divided>律师首页</el-dropdown-item>
            <el-dropdown-item>财务首页</el-dropdown-item>
            <el-dropdown-item @click.native="qute">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
export default {
  name: 'NavHeader',
  data() {
    return {
      indexPath:'/home',
      // 测试数据
      circleUrl: ''
    }
  },
  created() {
    // 初始化时设置默认tab
    const savedPath = window.localStorage.getItem('fullPath')
    this.indexPath = savedPath || '/home'
  },
  mounted() {
    if (this.userInfo.thumb) {
      this.circleUrl = `https://lsh.beishancloud.com/${this.userInfo.thumb}`
    }
  },

  updated() {
    if (this.userInfo.thumb) {
      this.circleUrl = `https://lsh.beishancloud.com/${this.userInfo.thumb}`
      const savedPath = window.localStorage.getItem('fullPath')
      if (savedPath) {
        this.indexPath = savedPath
      }
    }
  },

  methods: {
    ...mapMutations('m_tabs', ['changeNavShow']),
    ...mapMutations('m_user', ['changeuserinfo']),
    sendTips() {
      this.changeNavShow()
    },
    async clickHeaderNav(index) {
      
      window.localStorage.setItem('fullPath',index)
      this.indexPath = index
      const result = this.headerTabMenu.find(item => item.path === index).id
      await this.$store.dispatch('m_tabs/asyncGetAsideTabMenuData', result)
      // 手动路由跳转，避免重复导航
      // 只比较路径部分，忽略查询参数和哈希值
      const currentPath = this.$route.path.toLowerCase()
      const targetPath = index.toLowerCase()
      if (currentPath !== targetPath) {
        this.$router.push(index)
      }
 },
    qute() {
      this.changeuserinfo()
    }
  },
  computed: {
    ...mapState('m_tabs', ['headerTabMenu']),
    ...mapState('m_user', ['userInfo']),
    ...mapGetters('m_home', ['massageNum']),
    changeindexPath(){
        return 
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;
  height: 100%;
  font-size: 14px;
  font-family: HarmonyOS Sans SC;

  .left {
    .el-menu {
      border-bottom: none;

      .el-menu-item {
        color: #606266;
      }
    }
  }

  .right {
    display: flex;
    justify-content: space-between;
    align-items: center;

    position: absolute;
    right: 0;
    margin-right: 30px;
    width: 210px;

    .userbox {
      display: flex;
      align-items: center;

      .usertext {
        margin-right: 5px;
        color: #c0c4cc;
      }
    }
  }

  /*去掉tabs底部的下划线*/
  .el-tabs__nav-wrap::after {
    position: static !important;
  }
}
</style>